import { render, staticRenderFns } from "./PrgSrvRcrd.vue?vue&type=template&id=cda6aa46&"
import script from "./PrgSrvRcrd.vue?vue&type=script&lang=js&"
export * from "./PrgSrvRcrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports